import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppConstants } from "src/app/shared/constants/app.contants";
import { AuthenticationComponent } from "./components/authentication/authentication.component";
import { LoginComponent } from "./components/login/login.component";
import { ForgetEmailComponent } from "./components/forget-email/forget-email.component";
import { OtpComponent } from 'src/app/modules/authentication/components/otp/otp.component';
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { SuccessComponent } from "./components/success/success.component";
import { VendorRegistrationComponent } from "./components/vendor-registration/vendor-registration.component";
import { EmailVerificationComponent } from "./components/email-verification/email-verification.component";

export const routes: Routes = [
    {
        path: '',
        component: AuthenticationComponent,
        children: [
          { path: AppConstants.ROUTES.LOGIN, component: LoginComponent },

            {
                path: AppConstants.ROUTES.OTP_Page,
                component: OtpComponent
            },
            {
                path: AppConstants.ROUTES.FORGET_EMAIL,
                component: ForgetEmailComponent
              },
              {
                path: AppConstants.ROUTES.CHANGE_PASS,
                component: ChangePasswordComponent
              },
              {
                path: AppConstants.ROUTES.SUCCESS,
                component: SuccessComponent
              },
              {
                path: AppConstants.ROUTES.RegisterVendor,
                component: VendorRegistrationComponent
              },
              {
                path: AppConstants.ROUTES.verifyEmail,
                component: EmailVerificationComponent
              },
              { path: '', pathMatch: 'full', redirectTo: AppConstants.ROUTES.LOGIN }

        ]
    }
]

export const AUTHENTICATION_ROUTES: ModuleWithProviders<any> = RouterModule.forChild(routes);
